import { WaterUserDepositStatus } from "../enums/global.enums";

export function depositStatusPipe(value: string) {
    switch (value) {
        case WaterUserDepositStatus.All: return "Tất cả";
        case WaterUserDepositStatus.FullPaid: return "Đã đóng đủ";
        case WaterUserDepositStatus.HalfPaid: return "Đã đóng một nửa";
        case WaterUserDepositStatus.No: return "Chưa đóng";
    }
    return "";
}
